import type {
    IAudienceMatrixAPI,
    ISelectedDomain,
    IChartData,
} from "app/pages/website-analysis/audience-interests/single/types";
import { colorsPalettes } from "@similarweb/styles";
import dayjs from "dayjs";

const EMPTY_SELECTED_DOMAIN = { visitorsOf: null, alsoVisited: null };

export const getInitialSelectedDomains = (sites = []): ISelectedDomain => {
    if (sites.length < 2) {return EMPTY_SELECTED_DOMAIN;}
    const selectedDomains = { visitorsOf: sites[0], alsoVisited: sites[1] };
    return selectedDomains;
};

export const getChartData = (rawData: IAudienceMatrixAPI, selectedDomain: ISelectedDomain): IChartData => {
    if (!rawData) {return [];}
    const { visitorsOf, alsoVisited } = selectedDomain;
    const visitorsOfData = rawData[visitorsOf];
    if (!visitorsOfData) {return [];}
    const alsoVisitedData = visitorsOfData[alsoVisited];
    if (!alsoVisitedData || !alsoVisitedData.OverlapGraph) {return [];}
    const chartData = [
        {
            name: visitorsOf,
            color: colorsPalettes.blue[400],
            data: alsoVisitedData.OverlapGraph.map((graphItem) => {
                const { Key: key, Value: value } = graphItem;
                return { x: dayjs.utc(key).valueOf(), y: value };
            }),
        },
    ];
    return chartData;
};
